/** Firebase Auth actionCodeSettings for verification emails (continue URL after user verifies). */

export function getEmailVerificationActionCodeSettings() {
  const override = process.env.REACT_APP_VERIFICATION_CONTINUE_URL;
  if (override) {
    return { url: override, handleCodeInApp: false };
  }

  if (typeof window === 'undefined') {
    return { url: 'https://myroomsai.com/login?verified=1', handleCodeInApp: false };
  }

  const url = `${window.location.origin}/login?verified=1`;
  return { url, handleCodeInApp: false };
}
